export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.6147fc37.woff2";